import {Fragment} from 'react';
import {SaveButton, SaveButtonProps} from 'react-admin';

export const NirioSaveButton = (props: SaveButtonProps): JSX.Element => (
  <SaveButton icon={<Fragment />} variant="contained" {...props} />
);
